export type Attributes = Readonly<{
  className?: string;
  text?: string;
  id?: string;
  type?: string;
  href?: string;
  readOnly?: boolean;
  value?: string;
  ariaLabel?: string;
  title?: string;
  accept?: string;
}>;

type Child = Node | string;

export const el = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attributes: Attributes = {},
  children: readonly Child[] = [],
): HTMLElementTagNameMap[K] => {
  const element = document.createElement(tag);
  if (attributes.className !== undefined) element.className = attributes.className;
  if (attributes.id !== undefined) element.id = attributes.id;
  if (attributes.text !== undefined) element.textContent = attributes.text;
  if (attributes.title !== undefined) element.title = attributes.title;
  if (attributes.ariaLabel !== undefined) element.setAttribute('aria-label', attributes.ariaLabel);
  if (attributes.type !== undefined && (element instanceof HTMLInputElement || element instanceof HTMLButtonElement)) {
    element.type = attributes.type;
  }
  if (attributes.href !== undefined && element instanceof HTMLAnchorElement) element.href = attributes.href;
  if (attributes.accept !== undefined && element instanceof HTMLInputElement) element.accept = attributes.accept;
  if (attributes.readOnly !== undefined && element instanceof HTMLInputElement) element.readOnly = attributes.readOnly;
  if (attributes.value !== undefined && element instanceof HTMLInputElement) element.value = attributes.value;
  element.append(...children);
  return element;
};

export const clear = (element: HTMLElement): void => {
  element.replaceChildren();
};

export const show = (element: HTMLElement): void => {
  element.hidden = false;
};

export const hide = (element: HTMLElement): void => {
  element.hidden = true;
};
